import * as Sentry from '@sentry/vue'

const standardErrorMessage = 'Error: There was an error while submitting your request'
const genericErrorMessage = 'An unexpected error occurred. Please try again.'

const DefaultOptions = {
  timeout: 5000,
}

export const ALERT_TYPES = {
  ERROR: 'error',
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
}

export const AlertHandlerState = {
  snackbar: {
    _v: 0,
    isShowing: false,
    alert: {
      message: '',
      type: ALERT_TYPES.INFO,
    },
    options: {
      ...DefaultOptions,
    },
  },
}

const shouldReportToSentry = errorObject => {
  // Don't report HTTP client errors (4xx) to Sentry
  // These are expected business logic errors, not bugs
  if (errorObject?.response?.status >= 400 && errorObject?.response?.status < 500) {
    return false
  }
  return true
}

const extractErrorForSentry = errorObject => {
  // Convert Axios error to proper Error object for Sentry
  if (errorObject?.response) {
    const error = new Error(errorObject?.response?.data?.message || errorObject.message || 'HTTP Error')
    error.status = errorObject.response.status
    error.statusText = errorObject.response.statusText
    return error
  }
  return errorObject
}

export const AlertHandlerActions = {
  displayAlert: ({ commit, rootGetters }, { type, message, errorObject, options = {} }) => {
    const isLoggedIn = rootGetters.isLoggedIn
    let localMessage = message

    if (type === ALERT_TYPES.ERROR && errorObject && shouldReportToSentry(errorObject)) {
      Sentry.captureException(extractErrorForSentry(errorObject))
    }
    if (!isLoggedIn && type === ALERT_TYPES.ERROR) localMessage = standardErrorMessage
    // Never show a blank alert: fall back to a generic message if none was provided.
    if (type === ALERT_TYPES.ERROR && !localMessage) localMessage = genericErrorMessage

    commit('incrementVersion')
    commit('setAlert', { message: localMessage, type, options })
    commit('setIsShowing', true)
  },

  updateAlertShowing: ({ commit }, isShowing) => {
    commit('setIsShowing', isShowing)
  },

  clearAlert: ({ commit }) => {
    commit('setAlert', null)
  },
}

export const AlertHandlerGetters = {
  alert: state => state.snackbar.alert || {},
  isShowing: state => state.snackbar.isShowing || false,
  options: state => state.snackbar.options || {},
  alertVersion: state => state.snackbar._v || 0,
}

export const AlertHandlerMutations = {
  setAlert: (state, alert) => (state.snackbar.alert = alert),
  setIsShowing: (state, isShowing) => (state.snackbar.isShowing = isShowing),
  setOptions: (state, options) => (Object.assign(state.snackbar.options, options)),
  incrementVersion: state => (state.snackbar._v += 1),
}
